import { ArrowDown, ArrowRight, IconProps } from 'react-feather';

import { ArrowContainer } from 'components/common/ArrowIcon/components';
import useIsMobile from 'hooks/use-is-mobile';

const iconProps: IconProps = {
  size: 18,
  className: 'icon-style',
};

export default function ArrowIcon(): JSX.Element {
  const isMobile = useIsMobile();
  return <ArrowContainer>{isMobile ? <ArrowDown {...iconProps} /> : <ArrowRight {...iconProps} />}</ArrowContainer>;
}
